export default {
  integration: {
    pageTitle: 'Channel Management',
    pageDesc: 'Manage WeChat and Douyin mini program authorization to enable platform features.',

    wechatCardTitle: 'WeChat Mini Program',
    douyinCardTitle: 'Douyin Mini Program',
    alipayCardTitle: 'Alipay Mini Program',
    unionPayCardTitle: 'UnionPay Mini Program',
    xiaohongshuCardTitle: 'RED Mini Program',
    harmonyCardTitle: 'HarmonyOS Meta Service',
    notAuthorized: 'Not authorized yet',
    notAuthorizedShort: 'Unauthorized',
    notAuthorizedDesc: 'After authorization, the mini program can use your brand stores, products, and membership services.',
    douyinDesc: 'Click Authorize and follow the Douyin page instructions to complete binding.',
    waitingAuthorization: 'Pending',
    noMiniProgramTip: 'No mini program?',
    registerNow: 'Register',
    customize: 'Customize Mini Program',
    customizeDesc: 'Customize your mini program’s page layout and content.',
    customizeAuthorizedDesc: 'Arrange page layouts, configure image carousels, product displays, and navigation to create a mini program that reflects your brand.',
    authorizeNow: 'Authorize',
    scanToVisit: 'Scan with WeChat to visit',
    qrCodeAlt: 'WeChat Mini Program Code',
    qrCodeUnavailable: 'Mini program code unavailable',
    qrCodeUnavailableDesc: 'The mini program code is not available yet. Refresh it to try again.',
    refreshQrCode: 'Refresh Code',
    refreshQrCodeSuccess: 'Mini program code refreshed',
    downloadQrCode: 'Download Mini Program Code',
    downloadQrCodeSuccess: 'Mini program code downloaded',
    downloadQrCodeFailed: 'Failed to download the mini program code. Please try again.',

    appName: 'Mini Program Name',
    externalAppId: 'Mini Program AppID',
    principalName: 'Principal Name',
    miniProgramIntroduction: 'Mini Program Description',
    authorizationId: 'Authorization ID',
    status: 'Authorization Status',
    revision: 'Revision',
    lastSyncedTime: 'Last Synced Time',

    statusAuthorized: 'Authorized',
    statusRevoked: 'Revoked',
    statusInvalid: 'Invalid',

    startAuth: 'Start Authorization',
    reAuth: 'Re-authorize Current Mini Program',
    refreshMirror: 'Refresh Status',
    refreshSuccess: 'Authorization status refreshed',
    refreshRemoteMissing: 'No valid authorization found. Please confirm authorization is complete.',
    deauthorizationGuide: 'Deauthorization Guide',
    deauthorizationGuideTitle: 'Deauthorize WeChat Mini Program',
    deauthorizationGuideNotice: 'WeChat requires the mini program administrator to deauthorize it in WeChat Official Accounts Platform.',
    deauthorizationGuideStep1: 'Sign in to WeChat Official Accounts Platform with the mini program administrator account.',
    deauthorizationGuideStep2: 'Go to Settings → Third-Party Settings.',
    deauthorizationGuideStep3: 'Find the authorized third-party platform and follow the page instructions to deauthorize it.',
    deauthorizationGuideResult: 'After completion, the authorization status will automatically become Revoked.',
    openWechatPublicPlatform: 'Open WeChat Platform',

    manageMiniProgram: 'Manage Mini Program',
    managePageTitle: 'Manage Mini Program',
    managePageDesc: 'View WeChat Mini Program authorization information, and submit or release mini program versions.',
    basicInfoTitle: 'Basic Information',
    basicInfoDesc: 'Current authorized mini program information.',
    refreshBasicInfo: 'Refresh Basic Information',
    refreshBasicInfoSuccess: 'Basic information refreshed',
    authorizationPlatform: 'Authorization Platform',
    noAuthorizedMiniProgram: 'No authorized mini program information',
    versionInfoTitle: 'Version Management',
    versionInfoDesc: 'After submission, the system uploads the latest mini program version and sends it to WeChat for review.',
    queryAuditStatus: 'Query Review Status',
    queryAuditStatusSuccess: 'Review status updated',
    versionOperationResultUnknown: 'The result could not be confirmed. Reopen the page to confirm the latest status before continuing.',
    submitNewVersion: 'Submit New Version',
    releaseVersion: 'Release',
    submitVersionConfirm: 'Submit a new mini program version to WeChat for review?',
    releaseVersionConfirm: 'Release this approved mini program version?',
    submitVersionSuccess: 'New version task submitted',
    releaseVersionSuccess: 'Release task submitted',
    noVersionTask: 'No version task',
    noVersionTaskDesc: 'No submission records yet. Submit a new version to view review progress here.',
    reviewProgressTitle: 'Version Review Progress',
    reviewStepSubmit: 'Submit for Review',
    reviewStepWechat: 'WeChat Review',
    reviewStepResult: 'Review Result',
    reviewPassed: 'Approved',
    reviewTipPending: 'After submitting for review, you can check the status on this page. WeChat usually completes reviews within 3–4 business days; the final result is subject to WeChat.',
    reviewTipReviewing: 'WeChat usually completes reviews within 3–4 business days. This submission is still within the normal review period. Query the review status for updates.',
    reviewTipOverdue: 'This review has exceeded 4 business days. Please refer to the WeChat review result and query the review status.',
    reviewTipPassed: 'The latest version has passed WeChat review and can now be released.',
    currentOnlineVersion: 'Current Online Version',
    onlineReleaseTime: 'Last Release Time',
    latestAvailableVersion: 'Latest Open Platform Version',
    latestVersionNotFetched: 'Not retrieved',
    getLatestVersion: 'Get Latest Version',
    getLatestVersionSuccess: 'Latest version retrieved',
    checkingUpgradeAvailability: 'Checking for a new version',
    alreadyLatestVersion: 'The current version is up to date',
    taskTemplateVersion: 'Last Submitted Version',
    versionStatus: 'Version Status',
    submittedTime: 'Last Review Submission Time',
    statusSubmitting: 'Submitting new version',
    statusUnderReview: 'Under WeChat review',
    statusReviewRejected: 'Review rejected',
    statusReadyToRelease: 'Approved, ready to release',
    statusReleasing: 'Releasing',
    statusReleaseFailed: 'Release failed, ready to retry',
    statusReleased: 'Released',
    statusFailed: 'Version operation failed',

    authDialogTitle: 'Complete Authorization',
    authDialogTip: 'Sign in with the platform administrator account in the new page and complete authorization. If no page appears, use the button below to open it again.',
    authEntryExpireAt: 'Complete authorization before',
    openEntryUrl: 'Open Authorization Page',

    sessionStatus: 'Session Status',
    sessionPending: 'Waiting for authorization…',
    sessionAuthorized: 'Authorization succeeded',
    sessionFailed: 'Authorization failed',
    sessionExpired: 'The authorization link has expired. Please start again.',
    failureReason: 'Failure Reason',
    createSessionFail: 'Failed to open the authorization page. Please try again later.',
    done: 'Done',
  },
};
